import axios from 'axios'
import {to} from './utils'

export default {
  async getShops (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/${process.env.VUE_APP_API_VERSION}/shops`))
  },
  async searchShops (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/${process.env.VUE_APP_API_VERSION}/shops/availability`, body))
  },
  async shopDetail (body) {
    return to(axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/${process.env.VUE_APP_API_VERSION}/shop/details/${body.shop_id}`))
  },
  async getServices (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/${process.env.VUE_APP_API_VERSION}/services/availability`, body))
  }
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/endpoints/shop.js
// module id = null
// module chunks = 